import {
  FlexColumn, FormConfigurationProvider, InputRow, ModelInput, ModelNewNumericInput, RadioYesNoInput, ThemeType,
} from '@equifinance/shared';
import styled, { css, FlattenInterpolation, ThemeProps } from 'styled-components';
import { useCompanyContext } from '../../../../contexts/company';
import { PaddedSection } from '../../../Account/components/Section';

const CommercialsContainer = styled(FlexColumn)`${({ theme }) => `
  padding: 0 ${theme.padding[11]};
  gap: ${theme.padding[5]};
`}`;

const Grid = styled.div`${({ theme }) => `
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-row-gap: ${theme.padding[3]};
  align-items: center;
`}`;

const HeadCell = styled.div`${({ theme }) => `
  color: ${theme.colours.neutral[2]};
  font-weight: ${theme.fontWeight.bold};
  font-size: ${theme.fontSize[2]};
  padding: 0 ${theme.padding[1]} ${theme.padding[2]} ${theme.padding[4]};
`}`;

const Row = styled.div`
  display: contents;
`;

const LabelCell = styled.div`${({ theme }) => `
  background: ${theme.colours.neutral[8]};
  color: ${theme.colours.neutral[2]};
  font-weight: ${theme.fontWeight.bold};
  font-size: ${theme.fontSize[2]};
  border-radius: ${theme.padding[1]};
  padding: ${theme.padding[7]};
`}`;

const FieldCell = styled.div`${({ theme }) => `
  background: ${theme.colours.neutral[9]};
  padding: ${theme.padding[4]};
`}`;

export const CommercialsSectionRefName = 'commercials-section';
export const CollapsibleHeaderCss = css`${({ theme }) => `
  background: ${theme.colours.warning[3]};
`}` as FlattenInterpolation<ThemeProps<ThemeType>>;

export function CommercialsSection() {
  const { company: { commercialDetails } } = useCompanyContext();

  return (
    <PaddedSection
      id={CommercialsSectionRefName}
      refName={CommercialsSectionRefName}
      title="Commercials"
      headerCss={CollapsibleHeaderCss}
      isLocked
    >
      <FormConfigurationProvider isReadOnlyInput>
        <CommercialsContainer>
          <Grid>
            <HeadCell />
            <HeadCell>Commission rate</HeadCell>
            <HeadCell>Commission cap</HeadCell>
            <HeadCell>Clawback</HeadCell>

            {commercialDetails?.commissionDetails?.map((row, i) => (
              <Row key={row.type}>
                <LabelCell>{row.type}</LabelCell>

                <FieldCell>
                  <ModelNewNumericInput
                    field={`commercialDetails.commissionDetails[${i}].commissionRate`}
                    required
                    suffix="%"
                    valueOverride={((commercialDetails?.commissionDetails?.[i].commissionRate ?? 0) * 100).toString()}
                  />
                </FieldCell>

                <FieldCell>
                  <ModelNewNumericInput
                    field={`commercialDetails.commissionDetails[${i}].commissionCap`}
                    required
                    prefix="£"
                  />
                </FieldCell>

                <FieldCell>
                  <ModelNewNumericInput
                    field={`commercialDetails.commissionDetails[${i}].clawbackPeriod`}
                    required
                    suffix="months"
                  />
                </FieldCell>
              </Row>
            ))}
          </Grid>
          <InputRow>
            <ModelInput
              label="Approver"
              field="commercialDetails.approver"
              required
            />
            <RadioYesNoInput
              label="Packager?"
              field="commercialDetails.isPackager"
              required
            />
          </InputRow>
        </CommercialsContainer>
      </FormConfigurationProvider>
    </PaddedSection>
  );
}
